import { createFileRoute, useParams } from "@tanstack/react-router";
import { createRecordNotesListQueryOptions } from "@/features/notes/adapters/record-notes-adapter";
import { RecordNotesWorkspace } from "@/features/notes/components/record-notes-workspace";
import { NOTES_PAGE_SIZE } from "@/features/notes/types";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets/$assetId/workspace/records/$recordId/workspace/notes",
)({
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(
			createRecordNotesListQueryOptions({
				recordId: params.recordId,
				organizationId: params.orgId,
				start: 1,
				count: NOTES_PAGE_SIZE,
			}),
		),
	component: NestedRecordWorkspaceNotesTab,
});

/**
 * Nested record workspace Notes tab under an asset — thin route adapter.
 */
function NestedRecordWorkspaceNotesTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets/$assetId/workspace/records/$recordId/workspace/notes",
	});

	return (
		<RecordNotesWorkspace orgId={params.orgId} recordId={params.recordId} />
	);
}
